import script from "./page-render-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./page-render-cell.vue?vue&type=script&setup=true&lang=js"

import "./page-render-cell.vue?vue&type=style&index=0&id=9f308cf0&lang=scss"

const __exports__ = script;

export default __exports__